import React, { useMemo } from "react";
import { sharedLib } from "@shared/services/shared.service.ts";
import {
  DELETE_EXTERNAL_INVITATION_CACHE_KAY,
  INVITATION_CARD_COLUMN_SPANS,
} from "features/configuration/InviteExternalUsers/constants.ts";
import FlatList from "common/Lists/FlatList.tsx";
import {
  ExternalAccountInvitation,
  ExternalAccountInvitationWithKey,
} from "@shared/types";
import InvitationCard from "features/configuration/InviteExternalUsers/InvitationCard.tsx";
import useExpandedCardsSorters from "common/CardSorters/useExpandedCardsSorters.tsx";
import { ColumnType } from "@shared/common/CardsList/types.ts";
import { useWindowSize } from "react-use";

const InvitationCards = () => {
  const { data, isLoading, isFetching } =
    sharedLib.sharedApi.configuration.useGetAccountInvitesQuery();
  const deleteAccountInviteStatus =
    sharedLib.sharedApi.configuration.useDeleteAccountInviteMutation({
      fixedCacheKey: DELETE_EXTERNAL_INVITATION_CACHE_KAY,
    })[1];
  const { height } = useWindowSize();

  const parsedData = useMemo(
    () =>
      data?.map((invitation) => ({ ...invitation, key: invitation.token })) ||
      [],
    [data]
  );

  const columns: ColumnType<ExternalAccountInvitation>[] = [
    {
      key: InvitationsColumn.ACCOUNT_NAME,
      span: INVITATION_CARD_COLUMN_SPANS[0],
      title: "Account Name",
    },
    {
      key: InvitationsColumn.STATUS,
      span: INVITATION_CARD_COLUMN_SPANS[1],
      title: "Status",
    },
  ];

  const { sortedData, cardsSorters, toggleExpanded, isExpanded } =
    useExpandedCardsSorters({
      data: parsedData,
      columns,
    });

  const renderContent = ({
    item,
  }: {
    item: ExternalAccountInvitationWithKey;
  }) => {
    return (
      <InvitationCard
        invitation={item}
        isExpanded={isExpanded(item?.key)}
        toggleExpanded={toggleExpanded}
      />
    );
  };

  return (
    <div style={{ height: height * 0.6 }}>
      <FlatList
        data={sortedData || []}
        loading={isLoading}
        renderContent={renderContent}
        renderTopContainer={() => (
          <div style={{ marginBottom: 12 }}>{cardsSorters}</div>
        )}
        gap={12}
        refreshing={isFetching || deleteAccountInviteStatus.isLoading}
        hasActionButton={true}
      />
    </div>
  );
};

export default InvitationCards;

enum InvitationsColumn {
  ACCOUNT_NAME = "accountName",
  STATUS = "status",
}
